/* import __COLOCATED_TEMPLATE__ from './tags-cell.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';

interface CellTagsCellSignature {
  Args: {
    cell: unknown;
    column: unknown;
    row: unknown;
    scrollToRow: unknown;
  };
}

const CellTagsCellComponent = templateOnlyComponent<CellTagsCellSignature>();

export default CellTagsCellComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Cell::TagsCell': typeof CellTagsCellComponent;
    'cell/tags-cell': typeof CellTagsCellComponent;
  }
}
